import type { FieldProps } from 'formik';
import { Field } from 'formik';
import React from 'react';
import type { ButtonProps } from '../Button';
import Button from '../Button';
import LoadingIndicator from '../LoadingIndicator';

const FormikSubmitButton = ({ disabled = false, ...props }: ButtonProps) => (
  <Field name="__submitButton">
    {({ form: { isSubmitting } }: FieldProps) => (
      <Button
        type="submit"
        variant="primary"
        {...props}
        disabled={isSubmitting || disabled}
      >
        {isSubmitting ? (
          <LoadingIndicator delay={0} adaptColor />
        ) : (
          props.children
        )}
      </Button>
    )}
  </Field>
);

export default FormikSubmitButton;
